import addError from '../../../utils/error.jsx';
import { update, addToSportCollection } from './update';

export function request(data) {
    return {
        type: 'PARTICIPANTS_CREATE_REQUEST',
        data
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'PARTICIPANTS_CREATE_ERROR',
        errors
    };
}

export function finish(participant) {
    return dispatch => {
        dispatch(update(participant.id, participant));
        // dispatch(addToSportCollection(participant.sport.id, participant));

        dispatch({
            type: 'PARTICIPANTS_CREATE_FINISH',
            participant
        });
    };
}

export function clear() {
    return {
        type: 'PARTICIPANTS_CREATE_CLEAR'
    };
}
